<template>
    <div class="testing-page">
        <div>
            <div class="float-container">
                <div :style="{ backgroundColor: dynamicColor }" v-if="updatedStickersAndScores.length > 0" class="header">
                    <div>
                      <h4>Accuracy</h4>
                      <h1>{{ Math.abs(updatedStickersAndScores[0].instance_score) }} %
                      </h1>
                    </div>
                </div>
                <div class="row">
                  <div :style="{ borderColor: dynamicColor }" class="float-child column">
                      <p class="header-label">Trainer <!--  : Length of Trainer Data: {{  lengthOfTrainerData }} -->
                      </p>
                      <p class="loader" v-if="trainerDataLoaded"></p>
                      <hr></hr>
                      <canvas  id="trainerCanvas" height="500" width="600"></canvas>
                  </div>
                  <div :style="{ borderColor: dynamicColor }" class="float-child column">
                      <p class="header-label">User</p>
                      <p class="loader" v-if="userDataLoaded"></p>
                      <hr></hr>
                      <canvas id="userCanvas" height="500" width="600"></canvas>
                  </div>
                </div>
            </div>
            <div>
                <div class="time-label">
                  <span id="startTime">Start Time: {{ videoStartTime }} sec</span>
                  <span id="currentTime">Current Time: {{ sliderValue }} sec</span>
                  <span id="endTime">End Time: {{ videoEndTime }} sec</span>
                </div>
                <div class="row">
                  <div class="col">                    
                    <input type="range" :style="{ color: dynamicColor }" name="slider" :title="sliderValue" :min="videoStartTime" :max="videoEndTime" v-model="sliderValue" @input="updateKeyPoints()" :disabled="disableSlider" class="slider" style="background-color: green;"/>
                    <b-form-select   style="width: 5%; height: 35px; margin-bottom: 20px; margin-left: 30px;" v-model="timeDelay" :options="speedOptions"></b-form-select>
                  </div>
                </div>
              </div>
            <div class="angleTable">
              <table v-if="showTable" style="width:100%">
                <tr>
                  <th>Sticker</th>
                  <th>Average Accuracy Score</th>
                  <th>Instant Score</th>
                </tr>
                <tr v-if="updatedStickersAndScores.length > 0">
                  <th>{{ updatedStickersAndScores[0].message }}</th>
                  <th style="width:20%">{{ updatedStickersAndScores[0].instance_score }}</th>
                  <th style="width:20%">{{ updatedStickersAndScores[0].accuracy_score }}</th>
                </tr>
            </table>
          </div>
        </div>
        <div class="scoreGraph">
          <line-chart v-if="showGraph" :chart-data="chartData" :options="chartOptions"></line-chart>
        </div>
    </div> 
    </template>
    <script>
    import {drawConnectors, drawLandmarks} from "@mediapipe/drawing_utils/drawing_utils.js";
    import {Pose, POSE_CONNECTIONS} from "@mediapipe/pose/pose.js";
    import api from '../api.js';
    import LineChart from "@/module_user/components/LineChart";
    export default {
        data: function() {
            return {
                repData: {
                  rep_count: false,
                  Message: ''
                },
                stopFlag: false,
                exitStatus: '',
                dynamicColor: 'white',
                userVideoTime: null,
                trainerVideoTime: null,
                lengthOfTrainerData: null,
                lengthOfUserData: null,
                sessionId: '',
                startTime: null,
                endTime: null,
                videoStartTime: null,
                videoEndTime: null,
                showGraph: false,
                canvas: '',
                canvasCtx: '',
                userKeyPoints: null,
                trainerKeyPoints: null,
                scoresData: null,
                timeDelay: 1.0,
                sliderValue: 0,
                disableSlider: true,
                trainerDataLoaded: false,
                currentSticker:null,
                avgScore: null,
                instanceScore: null,
                chartData: {
                  labels: [],
                  datasets: [
                    {
                      label: 'Average Accuracy Score',
                      backgroundColor: 'green',
                      borderColor: 'green',
                      data: [],
                      fill: false
                    },
                    {
                      label: 'Instant Score',
                      backgroundColor: '#23B2E3',
                      borderColor: '#23B2E3',
                      data: [],
                      fill: false
                    }
                  ]
                },
              chartOptions: {
              responsive: true,
              maintainAspectRatio: false,
              fill: false
              },
              trainerAngles: {},
              userAngles: {},
              showTable: false,
              userDataLoaded: false,
              trainerDataLoaded: false,
              estimatedStartRequestTime:0,
              estimatedEndRequestTime:0,
              updatedStickersAndScores: {},
              speedOptions: [
                { value: 0.5, text: '0.5x' },
                { value: 1.0, text: '1.0x' },
                { value: 1.5, text: '1.5x' },
                { value: 2.0, text: '2.0x' },
                { value: 2.5, text: '2.5x' },
                { value: 3.0, text: '3.0x' }
            ]
            }
        },
        components: {
          LineChart
        },
        methods: {
            async getSessionIdData() {
                this.sliderValue = 0;
                this.scoresData = null;
                this.userKeyPoints = null;
                this.trainerKeyPoints = null;
                this.userDataLoaded = true;
                this.trainerDataLoaded = true;
                this.sessionId=this.$route.params.sessionId;
                console.log(this.sessionId);
                const requestData= {
                  "sessionId": this.sessionId
                }
                if (requestData.sessionId != null) {
                    this.disableSlider = false;
                    try {
                      this.scoresData = await api.getScoreData(requestData.sessionId);
                      this.userKeyPoints = await api.getSessionData(requestData);
                      let baseline_folder =  this.userKeyPoints[0].baseline_folder;
                      let video_id = this.userKeyPoints[0].video_id;
                      let videoData = await api.getVideoById(video_id);
                      this.videoStartTime = videoData.data.data.data.start;
                      this.videoEndTime = videoData.data.data.data.end;
                      this.sliderValue = this.videoStartTime;
                      this.startTime = this.videoStartTime;
                      this.endTime = this.videoEndTime;
                      this.trainerKeyPoints = await api.getTrainerData(baseline_folder);
                      this.lengthOfTrainerData = this.trainerKeyPoints.length;
                      this.lengthOfUserData = this.userKeyPoints.length;
                      this.drawGraph();    
                      this.exitStatus = await this.drawCanvas();
                      } catch(error) {
                        console.log(error);
                        this.trainerDataLoaded = false;
                        this.userDataLoaded = false;
                        this.$bvToast.toast('Unable to fetch data', {
                          title: 'Error',
                          variant: 'danger',
                        });
                    }  
                }
                else {
                  this.$bvToast.toast('Enter Missing Values', {
                    title: 'Missing Values',
                    variant: 'danger',
                  });
                }
            },
            async drawStickFigure(keypoints, canvas, canvasCtx) { 
              canvasCtx.clearRect(5, 10, 600, 500);     
              drawConnectors(canvasCtx, keypoints, POSE_CONNECTIONS);
              drawLandmarks(canvasCtx, keypoints);
            },
            async drawGraph() {
              for(let score of this.scoresData) {
                this.chartData.labels.push(`${score.start_time}-${score.end_time}`);
                this.chartData.datasets[0].data.push(score.accuracy_score);
                this.chartData.datasets[1].data.push(score.instance_score);
              }
              this.showGraph = true;
            },
            async drawCanvas() {
              const userCanvas = document.getElementById("userCanvas");
              const userCanvasCtx = userCanvas.getContext("2d");
              const trainerCanvas = document.getElementById("trainerCanvas");
              const trainerCanvasCtx = trainerCanvas.getContext("2d");
              if(this.sliderValue >= this.startTime) {
                this.stopFlag = false;
                for(let userKeyPoint of this.userKeyPoints) {
                  if (this.sliderValue > this.startTime) {
                    if(this.stopFlag) {
                      return 'exited';
                    }
                    this.userVideoTime = userKeyPoint.time;
                    this.showTable = true;
                    let currentTrainerKeyPoints = this.trainerKeyPoints.filter(function(trainerKeyPoint) {
                      return Math.abs(trainerKeyPoint.time) == Math.abs(userKeyPoint.time);
                    })
                    if(currentTrainerKeyPoints.length > 0) {
                      this.trainerDataLoaded = false;
                      this.userDataLoaded = false;
                      await this.updateScoresTable(this.userVideoTime);
                      this.drawStickFigure(currentTrainerKeyPoints[0].steps.pose, trainerCanvas, trainerCanvasCtx);
                      this.drawStickFigure(userKeyPoint.steps.pose, userCanvas, userCanvasCtx);
                    }
                    this.sliderValue = Math.abs(userKeyPoint.time);
                    if(this.sliderValue > this.endTime) {
                      break;
                    }
                    await this.sleep(this.timeDelay*100);
                  }
                  else {
                    this.sliderValue = parseInt(this.sliderValue) + 1;
                  }
                }
              }
            },
            async updateScoresTable(userVideoTime) {
                this.updatedStickersAndScores = this.scoresData.filter(function (scores) {
                  return scores.start_time >= parseInt(userVideoTime) && scores.end_time <= parseInt(userVideoTime) + 10;
                })
                if (this.updatedStickersAndScores[0] !== undefined) {
                  if (parseInt(this.updatedStickersAndScores[0].instance_score) < 90 && parseInt(this.updatedStickersAndScores[0].instance_score) > 40) {
                    this.dynamicColor = '#FFC700';
                  }
                  else if(parseInt(this.updatedStickersAndScores[0].instance_score) < 40) {
                    this.dynamicColor = '#EA5C5C'; 
                  }
                  else {
                    this.dynamicColor = '#73BC44';
                  }
                }
            }, 
            async updateKeyPoints() {
              this.startTime = this.sliderValue;
              this.stopFlag = true;
              this.trainerDataLoaded = false;
              this.userDataLoaded = false;
              setTimeout(() => {
                this.drawCanvas();
              }, 1000);
            },
            async sleep(ms) {
              return new Promise(resolve => setTimeout(resolve, ms));
            }
          },
          mounted() {
            this.getSessionIdData();
          },
        }
    </script>
    <style lang="scss" scoped>
    .float-container {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        border-radius: 5px;
    }
    
    .input-box {
      border-radius: 5px;
      padding:5px;
    }
    
    .large-input-box {
      width: 22%;
    }
    
    .float-child {
        width: 50%;
        float: left;
        border: 10px solid white;
    }  
    hr {
        color:white;
    }
    
    .slider {
      width: 90%;
      padding: 10px;
      margin: 10px;
      color: green;
      /* background-color: green; */
    }
    
    .angle-red {
      background-color: red;
    }
    
    .angle-green {
      background-color: green;
    }

    .speed-drop-down{
      background-color: white;
      height: 40px;
      width: 100px;
    }
    
    .time-label {
      color: white;
      padding: 10px;
      font-size: 20px;
    }
    
    #startTime {
      width: 34%;
      float:left;
      text-align: left;
    }
    
    #currentTime {
      width: 33%;
      float: left;
      text-align: center;
    }
    
    #endTime {
      width: 33%;
      float: left;
      text-align: right;
    }
    
    .scoreGraph{
      background-color: white;
    }
    
    .testing-page{
      background-color: black;
    }
    
    .angleTable{
      background-color: white;
      color: black;
    }
    
    table, th, td {
      margin: auto;
      border:2px solid black;
    }
    
    .header-label{
      color: white;
      text-align: center;
      font-size: 28px
    }

    .header {
      margin: auto;
      color: white;
      height: 100px;
      width: 8%;
      position: absolute;
      margin-left: 43.5%;
      text-align: center;
      border: 6px;
      border-radius: 5px;
    }

    .column {
      flex: 1;
    }
    </style>